const state = {
    currentUnitIds: localStorage.getItem('currentUnitIds') ? JSON.parse(localStorage.getItem('currentUnitIds')) : []
}

const mutations = {
    // 设置选中的区域id
    SET_CURRENT_UNIT_IDS(state, unitidArr) { 
        state.currentUnitIds = unitidArr
        localStorage.setItem('currentUnitIds', JSON.stringify(unitidArr))
    },
    // 清空区域id
    EMPTY_UNIT_IDS(state) { 
        state.currentUnitIds = ['3e2fe4faa399476786dda82bde78052c']
        localStorage.setItem('currentUnitIds', JSON.stringify(['3e2fe4faa399476786dda82bde78052c']))
    }
}

const actions = {

}
export default {
    state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/area.js